import { Divider, GroupBox, Theme } from '@infotech-soe/erp-ui-kit';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import { AboutPreferencesPaneContainerProps } from './AboutPreferencesPaneContainer';

declare const MIA_ERP_VERSION: string;

const messages = defineMessages({
  system: {
    id: 'core.preferencesDialog.system',
    defaultMessage:
      '"МІА® ERP",\nserver version {serverVersion},\nclient version {clientVersion}',
  },
  systemCopyright: {
    id: 'core.preferencesDialog.systemCopyright',
    defaultMessage: '© 2026 State Enterprise «INFOTECH»',
  },
  projectInfo: {
    id: 'core.preferencesDialog.projectInfo',
    defaultMessage: '{name}, version {version}',
  },
  copyright: {
    id: 'core.preferencesDialog.copyright',
    defaultMessage: '© {year} State Enterprise «INFOTECH»',
  },
});

const useStyles = createUseStyles(({ colors }: Theme) => ({
  content: {
    padding: '24px',
    whiteSpace: 'pre-line',
    display: 'flex',
    alignItems: 'center',
    gap: 24,
  },
  logo: {
    width: 100,
    height: 100,
    flexShrink: 0,
    backgroundColor: (isDarkTheme: boolean) =>
      isDarkTheme ? '#FFFFFF' : '#14379F',
    '--webkit-mask': 'url(logo.svg) no-repeat center',
    mask: 'url(logo.svg) no-repeat center',
  },
  textContent: {
    flex: 1,
  },
  infoBlock: {
    marginBottom: 16,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  projectInfo: {
    marginBottom: 8,
    color: colors.typoCommon,
    fontWeight: 700,
  },
  systemInfo: {
    marginBottom: 8,
    color: colors.typoCommon,
  },
  subtitle: {
    color: colors.typoCaption,
    marginBottom: 8,
  },
  divider: {
    marginBottom: 16,
  },
}));

const AboutPreferencesPane = ({
  isDarkTheme,
  projectInfo,
}: AboutPreferencesPaneContainerProps): React.JSX.Element => {
  const { formatMessage } = useIntl();
  const classes = useStyles(isDarkTheme);

  return (
    <GroupBox>
      <GroupBox.Content className={classes.content}>
        <div className={classes.logo} />
        <div className={classes.textContent}>
          {projectInfo.name && (
            <div className={classes.projectInfo}>
              {formatMessage(messages.projectInfo, {
                name: projectInfo.name,
                version: projectInfo.version,
              })}
            </div>
          )}
          {projectInfo.name ? (
            <>
              <div className={classes.infoBlock}>
                <div className={classes.subtitle}>
                  {formatMessage(messages.copyright, {
                    year: projectInfo.copyrightYear,
                  })}
                </div>
              </div>
              <Divider className={classes.divider} />
              <div className={classes.infoBlock}>
                <div className={classes.systemInfo}>
                  {formatMessage(messages.system, {
                    serverVersion: projectInfo.merpsVersion,
                    clientVersion: MIA_ERP_VERSION,
                  })}
                </div>
                <div className={classes.subtitle}>
                  {formatMessage(messages.systemCopyright, {})}
                </div>
              </div>
            </>
          ) : (
            <div className={classes.infoBlock}>
              <div className={classes.subtitle}>
                {formatMessage(messages.system, {
                  serverVersion: projectInfo.merpsVersion,
                  clientVersion: MIA_ERP_VERSION,
                })}
              </div>
              <div className={classes.subtitle}>
                {formatMessage(messages.systemCopyright, {})}
              </div>
            </div>
          )}
        </div>
      </GroupBox.Content>
    </GroupBox>
  );
};

export default AboutPreferencesPane;
